import { POWER_CURVE } from '../types'

export const setPCDateRange = dateRange => ({
  type: POWER_CURVE.DATE,
  payload: dateRange,
})

export const setPCPlant = plant => ({
  type: POWER_CURVE.PLANT,
  payload: plant,
})
